import React from 'react';
import { AppHeader } from 'src/components/ui';
import { MessageTemplateCreateForm } from './messageTemplate.create';

export const MessageTemplateCreatePage: React.FC = () => {
  return (
    <AppHeader>
      <MessageTemplateCreateForm />
    </AppHeader>
  );
};
